/* istanbul ignore file */

import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {};

export default function AddeparIcon({ ...props }: Props) {
    return (
        <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            role="img"
        >
            <g clipPath="url(#clip0_6_18296)">
                <path
                    d="M4.89057 0.5L0.5 7.48569H3.93829L8.32886 0.5H4.89057Z"
                    fill="black"
                />
                <path
                    d="M11.4976 7.48699H8.05864L5.99756 4.20703H9.43742L11.4969 7.48699H11.4976Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_6_18296">
                    <rect
                        width="11"
                        height="7"
                        fill="white"
                        transform="translate(0.5 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
